const subdomain =
  /((app[.])|(staging[.])|((?<subDomain>[a-zA-Z0-9-]+)[.])?)((staging)[.])?((leaseup[.]co)|(leaseup-test[.]co)|(localhost))/

export const parseSubdomain = (url = location.hostname) => {
  return url.match(subdomain)?.groups?.subDomain
}
